import { CheckIcon, StarIcon, CheckCircleIcon } from '@heroicons/react/24/outline'

const SubscriptionPlanCard = ({ plan, highlighted, onGetStarted, isCurrentPlan = false }) => {
  return (
    <div className="relative rounded-3xl p-8 bg-gradient-to-br from-white to-gray-50 border border-gray-200 shadow-xl hover:shadow-2xl transition-all duration-300">
      {isCurrentPlan && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <div className="flex items-center space-x-2 bg-green-500 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
            <CheckCircleIcon className="w-4 h-4" />
            <span>Current Plan</span>
          </div>
        </div>
      )}

      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          {!isCurrentPlan && (
            <div className="w-3 h-3 rounded-full bg-gradient-to-r from-secondary-700 to-secondary-700"></div>
          )}
          <h3 className="text-2xl font-bold text-gray-900">{plan.name}</h3>
        </div>
        {highlighted && !isCurrentPlan && (
          <div className="flex items-center space-x-1 bg-gradient-to-r from-secondary-700 to-secondary-700 text-white px-3 py-1 rounded-full text-sm font-medium">
            <StarIcon className="w-4 h-4" />
            <span>Popular</span>
          </div>
        )}
      </div>

      {/* Price Section */}
      <div className="mb-8">
        <div className="flex items-baseline space-x-2">
          <span className="text-4xl font-extrabold text-gray-900">{plan.priceText}</span>
          <span className="text-lg text-gray-500">/month</span>
        </div>
        {plan.summary && (
          <p className="text-gray-600 mt-3 text-lg leading-relaxed">{plan.summary}</p>
        )}
      </div>

      <div className="mb-8">
        <h4 className="text-lg font-semibold text-gray-900 mb-4">What's included</h4>
        <ul className="space-y-3">
          {plan.description &&
            plan.description.split('\n').map((feature, idx) => (
              <li key={idx} className="flex items-start text-gray-700">
                <CheckIcon className="w-5 h-5 text-success-500 mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-base leading-relaxed">{feature}</span>
              </li>
            ))}
        </ul>
      </div>

      {isCurrentPlan ? (
        <div className="text-sm text-gray-500 italic">
          You are currently subscribed to this plan.
        </div>
      ) : (
        <button
          type="button"
          className="w-full py-4 rounded-2xl font-semibold text-lg bg-gradient-to-r from-secondary-700 to-secondary-500 text-white hover:from-button-orange-end hover:to-button-orange-start transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          onClick={(e) => {
            e.stopPropagation()
            onGetStarted && onGetStarted()
          }}
        >
          Get started today
        </button>
      )}
    </div>
  )
}

export default SubscriptionPlanCard
